// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"009379fd","351":"dd967a8b","403":"05c422d0","453":"4b5cf785","457":"1a392242","510":"bb25d84c","752":"4d60c824","780":"09f0a9d4"}[chunkId] + ".chunk.js";
};